import React from 'react';
import { Section, Heading, Eyebrow } from '../Section';
import { SectionCTA } from '../SectionCTA';
import { IMAGES } from '../../data/content';
export function AuthorMessage() {
  return <Section tone="navy" data-id="element-79" data-mp="2lvoafchzohab">
      <Eyebrow tone="dark" data-id="element-80" data-mp="2lwfym299bcqk">Un mensaje personal</Eyebrow>
      <Heading className="text-white" data-id="element-81" data-mp="2quhrfewhiqf8">
        Un mensaje de la <span className="italic text-brand-light" data-id="element-82" data-mp="2qty93x2xa00o">Dra. Karito</span>
      </Heading>

      <div className="mt-7 flex justify-center" data-id="element-83" data-mp="1t7sism7a1fke">
        <img src={IMAGES.karito} alt="Retrato de la Dra. Karito" className="h-36 w-36 rounded-full object-cover ring-4 ring-brand-light/30 sm:h-44 sm:w-44" loading="lazy" data-id="element-84" data-mp="1t93nco8jqrck" />
      </div>

      <div className="mx-auto mt-6 max-w-xl space-y-4 text-[15px] leading-relaxed text-white/80 sm:text-[17px]" data-id="element-85" data-mp="2849ujejdow7h">
        <p data-id="element-86" data-mp="3ej0qr4xk3sv6">
          Cuando empecé a atender pacientes con diabetes, me di cuenta de que el verdadero desafío no
          era conocer las guías.
        </p>
        <p className="font-serif text-lg font-bold italic text-white sm:text-2xl" data-id="element-87" data-mp="2ijnq19jnx0w3">
          Era tomar la decisión correcta cuando el paciente estaba sentado frente a mí.
        </p>
        <ul className="grid gap-2 sm:grid-cols-3" data-id="element-88" data-mp="2diqbr81rwqzv">
          {['Con poco tiempo.', 'Con múltiples comorbilidades.', 'Con la responsabilidad de elegir.'].map(item => <li key={item} className="rounded-xl bg-white/[0.07] px-3.5 py-2.5 text-[13px] font-semibold text-white/85" data-id="element-89" data-mp="24jlavv2qolkj">
                {item}
              </li>)}
        </ul>
        <p data-id="element-90" data-mp="1pugvelnbwvg4">
          Por eso desarrollé este Sistema de Decisión Clínica. No para sustituir tu criterio, sino para
          darte una estructura que te permita decidir con mayor rapidez, confianza y respaldo
          científico.
        </p>
        <p className="border-l-2 border-brand-light pl-4 font-semibold text-white" data-id="element-91" data-mp="1gtinvtdom5ss">
          Mi deseo es que, a partir de hoy, nunca más tengas que enfrentar una consulta sintiendo que
          te falta una respuesta.
        </p>
        <p className="font-serif text-xl font-bold text-brand-light" data-id="element-92" data-mp="176oj666bt2cq">— Dra. Karito</p>
      </div>

      <SectionCTA tone="dark" promise="Lleva a tu consulta la estructura que a mí me habría cambiado los primeros años." label="Quiero empezar hoy mismo" data-id="element-93" data-mp="s9fc844jhpzw" />
    </Section>;
}